import { FusionSettingsApi, useFusionSettingsAPI } from "melco-shared-logic";
import { useCallback } from "react";
import { ConfiguratorSettingsFormValueType } from "./useConfiguratorSettingsFormSubmit";

const initialValue = { settings: undefined };

export type ConfiguratorSettingsResult = {
  settings?: ConfiguratorSettingsFormValueType;
};

export const useConfiguratorSettings = () => {
  const handleRequest = useCallback(async (api: FusionSettingsApi) => {
    const { version } =
      await api.settingsGetFusionConfiguratorSetting();

    return {
      settings: {
        version,
      },
    };
  }, []);

  return useFusionSettingsAPI<ConfiguratorSettingsResult>({
    initialValue,
    handleRequest,
  });
};
